import { dispatch, useReframe } from 'nike-re-framejs';
import { useEffect } from 'react';
import { channelStatusPush, channelStatusSnapshot } from './handlers';
import { PUSH_PATHS } from '../paths';
import { subscribePath, unsubscribePath } from '../pushSubscriptions';
import { channelStatus$$ } from './subs';
import { ChannelState } from '../../dto';

export function useChannelStatusPush() {
    useEffect(() => {
        const path = PUSH_PATHS.channelStatus();
        subscribePath(path, {
            onSnapshot: data => dispatch(channelStatusSnapshot(data)),
            onMessage: data => dispatch(channelStatusPush(data))
        });
        return () => unsubscribePath(path);
    }, []);
}

export function useChannelStatus(channelId: number): ChannelState | undefined {
    useChannelStatusPush();
    const derefSub = useReframe();
    return derefSub(channelStatus$$(channelId));
}
